import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import App from "./App.tsx";
import Home from "./pages/Home.tsx";
import Product from "./pages/Product.tsx";
import Cart from "./pages/Cart.tsx";
import "./index.css";
import "./report.ts";

// 发布新版本之后,还开着旧页面的用户点进一个按需加载的路由,会去请求旧的 chunk 文件名,已经不存在了。
// Vite 在这种失败时发 vite:preloadError,这里的处理是整页刷新,拿新版本(第 24 章)
addEventListener("vite:preloadError", (e) => { e.preventDefault(); location.reload(); });
import "./vitals.ts";

// 后台只有管理员会打开,它依赖的图表库不该跟着商品页一起下载:按需加载
const Admin = lazy(() => import("./pages/Admin.tsx"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route index element={<Home />} />
          <Route path="p/:slug" element={<Product />} />
          <Route path="cart" element={<Cart />} />
          <Route path="admin" element={<Suspense fallback={<p className="empty">加载中…</p>}><Admin /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
